import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'Rank'
})
export class ParseRankPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    return value > 0 ? '+'.concat(value.toString()) :
    '-'.concat(value.toString());
  }

}
